// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V-HP","question":"styles_question__2xV97","description":"styles_description__1Z6d8"};